export const CONTACT_CANDIDATES = [
    // { value: 5, label: '検討の進め方について相談したい' },
    // { value: 6, label: '今抱えている課題の解決策について相談したい' },
    // { value: 7, label: 'おすすめのコンサルを聞きたい' },
    // { value: 8, label: 'コンサルを頼む際の予算や進め方を教えてほしい' },
    // { value: 3, label: 'いくつかプロジェクト事例を提案してほしい' },
    // { value: 1, label: 'サービスの利用方法について教えてほしい' },
    // { value: 2, label: 'プロジェクト事例の内容について質問したい' },
    { label: 'PROFFITのサービスや活用事例について聞きたい', value: 9 },
    { label: 'コンサルの活用方法について相談したい', value: 10 },
    { label: 'コンサルにかかる費用について教えてほしい', value: 11 },
    { label: 'その他', value: 4 },
];
export const HELP_CONTACT_CATEGORY_USER_TYPE_CLIENT = 1;
export const HELP_CONTACT_CATEGORY_USER_TYPE_PROFESSIONAL = 2;
export const HELP_CONTACT_CATEGORY_USER_TYPE_PROFFIT_SEARCH = 3;
export const HELP_CONTACT_CATEGORY_USER_TYPE_OTHER = 9;
